export enum BookingGenderCode {
  Indiferent = -1,
  Man = 0,
  Woman = 1,
  Others = 2,
}

export const DEFAULT_BOOKING_GENDER = BookingGenderCode.Indiferent;
